module.exports = __webpack_public_path__ + "static/media/ft2-end.0ba3da69.png";